module.exports = __webpack_public_path__ + "img/f20.0d42b39a.jpg";